const invoicesEN = {
    "view": {
        "table": {
            "title": "Your Invoices list",
            "column": {
                "issueDate": "Issue Date",
                "invoiceNumber": "Invoice Number",
                "status": "Status",
                "totalAmount": "Total Amount",
                "downloadPDF": "Download PDF",
                "whtStatement": "WHT Statement",
            },
            "label": {
                "notApplicable": "Not Applicable",
            },
            "placeholder": {
                "search": "Search...",
            },
            "button": {
                "download": "Download",
                "exportCSV": "Export CSV",
            },
        },
        "message": {
            "cantAddInvoices": "Unfortunately, you can not currently add invoices. Either your tax or payment account data is not fully completed. In order to unlock this feature, please contact our support team.",
            "invoicingNotAvailable": "Generate invoices from the 3rd to the 22nd of each month. Please note that invoice generation is not possible from the 23rd until the 2nd of the next month, as automatedpayments are processed during this period. Thank you for your understanding.",
            "generatingInvoices": "You can not add invoices at the moment as you have invoices which are currently generating. Please check back later.",
            "noAccess": "You don't have access to this module, please contact the support team for further information.",
            "subscriptionExpired": "Your subscription has expired. Please <1>resume</1> your subscription to avail this feature.",
            "subscriptionUpgrade": "Your current subscription plan does not support this feature. Please <1>upgrade</1> your subscription plan to avail this feature.",
        },
    },
    "add": {
        "title": "Add Invoice",
        "form": {
            "table": {
                "statements": {
                    "title": "Statements available for invoicing",
                }
            },
            "button": {
                "generateInvoice": "Generate Invoice",
            },
        },
        "message": {
            "success": "Invoice has been added!",
            "error": "Something went wrong! Please refresh page and try again!",
            "noStatementAvailable": "No statement available for invoicing.",
            "invoicingLimitNotReached": "You can not currently add invoices as total payable sum is less than or equal to <strong>0€</strong>.",
        },
        "modal": {
            "header": "Add Invoice",
            "body": "Are you sure you want to create invoice for currently OPEN Statements?",
        },
    },
};
export default invoicesEN;